import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Artists', path: '/artists' },
  { name: 'Styles', path: '/styles' },
  { name: 'Portfolio', path: '/portfolio' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'FAQ', path: '/faq' },
  { name: 'Contact', path: '/contact' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => setIsOpen(false), [location]);

  return (
    <header 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-primary/95 backdrop-blur-md py-4 shadow-xl' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center">
        <Link to="/" className="text-2xl font-display font-bold text-light flex items-center gap-2 group">
          <SafeIcon icon="Anchor" className="text-secondary group-hover:rotate-12 transition-transform" />
          BLACK ANCHOR
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.path}
              className={`text-sm tracking-widest uppercase transition-colors hover:text-secondary ${
                location.pathname === link.path ? 'text-secondary font-medium' : 'text-light'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link 
            to="/booking"
            className="border border-secondary text-secondary px-6 py-2 hover:bg-secondary hover:text-primary transition-all duration-300 text-sm uppercase tracking-wider"
          >
            Book Now
          </Link>
        </nav>

        {/* Mobile Toggle */}
        <button 
          className="lg:hidden text-light text-2xl"
          onClick={() => setIsOpen(!isOpen)}
        >
          <SafeIcon icon={isOpen ? FiX : FiMenu} />
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="lg:hidden absolute top-full left-0 w-full bg-primary border-t border-gray-800 shadow-2xl"
          >
            <div className="flex flex-col py-4 px-6 gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`text-lg py-2 border-b border-gray-800 ${
                    location.pathname === link.path ? 'text-secondary' : 'text-light'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link 
                to="/booking"
                className="bg-secondary text-primary text-center py-3 mt-4 font-medium"
              >
                BOOK CONSULTATION
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;